<template>
    <NuxtLink class="text-decoration-none" to="/" @click.prevent="handleLogoClick">
        <div class="d-flex align-center">
            <img src="/assets/images/thebunker-logo.webp" :alt="config.public.appLogoAltText || 'The Bunker Logo'"
                width="34" height="34" class="mr-3" cover />

            <div class="d-flex align-center font-weight-medium text-h5">
                <span :style="`color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity))`">
                    {{ nameFirst }}
                </span>

                &ThickSpace;

                <span v-if="nameRest" class="text-primary">
                    {{ nameRest }}
                </span>
            </div>
        </div>
    </NuxtLink>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()
const route = useRoute()

const splitName = computed(() => {
    const raw = String(config.public.appName || '').trim()
    const parts = raw.split(/\s+/).filter(Boolean)

    return {
        first: parts[0] ?? '',
        rest: parts.slice(1).join(' '),
    }
})

const nameFirst = computed(() => splitName.value.first)

const nameRest = computed(() =>
    splitName.value.rest
        ? ` ${splitName.value.rest}`
        : ''
)

const handleLogoClick = async () => {
    /*
     * On another page:
     * simply navigate back to the homepage.
     */
    if (route.path !== '/') {
        await navigateTo('/')
        return
    }

    /*
     * Already on homepage:
     * smoothly return to Home.
     */
    const home = document.getElementById('home')

    if (home) {
        home.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })

        return
    }

    /*
     * Fallback in case #home isn't available.
     */
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    })
}
</script>

<style scoped>
.mr-3 {
    margin-right: 12px;
}
</style>